export enum ObservationMenuItemType {
    SET_FOCUS,
    COPY_NOTES_TO_NEW_FOCUS,
    LINK,
    UNLINK,
    START_COMMITMENT,
    UPDATE_COMMITMENT,
    DELETE,
}

export interface ObservationMenuItem {
    type: ObservationMenuItemType;
    label: string;
    icon: string;
}
